<div class="selector-page">
  <div class="selector-card">
    <div class="logo-container">
      <img src="assets/VericureLogo1.png" alt="Vericure" class="logo" />
    </div>

    <h2>Select Customer</h2>
    <p class="subtitle">Choose the customer account you want to manage</p>

    <div class="loading" *ngIf="isLoading">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <span>Loading customers…</span>
    </div>

    <div class="error-message" *ngIf="errorMessage">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ errorMessage }}
    </div>

    <ng-container *ngIf="!isLoading && !errorMessage && customers.length > 1">
      <div class="search-box" *ngIf="useSearch">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          type="text"
          placeholder="Search customers…"
          [(ngModel)]="searchTerm"
          autocomplete="off"
        />
      </div>

      <!-- String [value] binding — more reliable than [ngValue] object comparison -->
      <select
        *ngIf="!useSearch"
        class="customer-select"
        [(ngModel)]="selectedCustomerId"
      >
        <option *ngFor="let c of customers" [value]="c.CustomerId">{{ c.CustomerName }}</option>
      </select>

      <div class="search-results" *ngIf="useSearch">
        <div
          class="search-result-item"
          *ngFor="let c of filteredCustomers"
          [class.selected]="selectedCustomerId === c.CustomerId"
          (click)="selectedCustomerId = c.CustomerId"
        >
          {{ c.CustomerName }}
        </div>
        <div class="no-results" *ngIf="filteredCustomers.length === 0">
          No customers match "{{ searchTerm }}"
        </div>
      </div>

      <button
        class="continue-btn"
        [disabled]="!selectedCustomerId"
        (click)="onContinue()"
      >
        Continue
      </button>
    </ng-container>
  </div>
</div>
